import { render, staticRenderFns } from "./MomentsAgo.vue?vue&type=template&id=30a12031"
import script from "./MomentsAgo.vue?vue&type=script&lang=js"
export * from "./MomentsAgo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports